module.exports = __webpack_public_path__ + "img/zbgg.ba188de5.png";